import { render, staticRenderFns } from "./EmployeeBiodata.vue?vue&type=template&id=4a896151&"
import script from "./EmployeeBiodata.vue?vue&type=script&lang=js&"
export * from "./EmployeeBiodata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports